var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLines(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 139.81 147.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#212535;}.cls-2{fill:none;opacity:.04;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 29.42,
    y: 17.98,
    width: 45.71,
    height: 5.38,
    rx: 2.69,
    ry: 2.69
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 79.65,
    y: 17.98,
    width: 45.71,
    height: 5.38,
    rx: 2.69,
    ry: 2.69
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.6,
    y: 28.16,
    width: 45.71,
    height: 5.38,
    rx: 2.69,
    ry: 2.69
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.79,
    y: 28.16,
    width: 27.13,
    height: 5.38,
    rx: 2.69,
    ry: 2.69
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 49.85,
    y: 38.41,
    width: 45.71,
    height: 5.38,
    rx: 2.69,
    ry: 2.69
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.86,
    y: 69.4,
    width: 45.71,
    height: 5.38,
    rx: 2.69,
    ry: 2.69
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 89.02,
    y: 69.4,
    width: 35.38,
    height: 5.38,
    rx: 2.69,
    ry: 2.69
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 28.45,
    y: 78.99,
    width: 45.71,
    height: 5.38,
    rx: 2.69,
    ry: 2.69
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 47.99,
    y: 98.53,
    width: 45.71,
    height: 5.38,
    rx: 2.69,
    ry: 2.69
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 38.33,
    y: 108.19,
    width: 45.71,
    height: 5.38,
    rx: 2.69,
    ry: 2.69
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 91.99,
    y: 108.19,
    width: 27.42,
    height: 5.38,
    rx: 2.69,
    ry: 2.69
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 28.52,
    y: 118,
    width: 45.71,
    height: 5.38,
    rx: 2.69,
    ry: 2.69
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 11.37,
    y: 88.65,
    width: 99.2,
    height: 5.38,
    rx: 2.69,
    ry: 2.69
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 11.15,
    y: 48.52,
    width: 84.41,
    height: 5.38,
    rx: 2.69,
    ry: 2.69
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 38.65,
    y: 59.22,
    width: 84.41,
    height: 5.38,
    rx: 2.69,
    ry: 2.69
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines);
export default __webpack_public_path__ + "static/media/lines.189b92e900baf2857706e05749ab9878.svg";
export { ForwardRef as ReactComponent };